import {
  BiometricPromptTrackingPoint,
  ReloginBiometricsTrackingPoint,
  ReloginPasswordTrackingPoint,
} from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const BiometricPromptTrackingSchema: Record<
  BiometricPromptTrackingPoint,
  string
> = {
  [BiometricPromptTrackingPoint.PageView]:
    '7fc6eddd-254f-4407-affc-45355a461bc9',
  [BiometricPromptTrackingPoint.BackClick]:
    'db54ade8-269c-4baa-91d3-0d338d5c4dd0',
  [BiometricPromptTrackingPoint.EnableBiometricClick]:
    'b70973d2-aa01-4657-aca1-b62814986bbe',
  [BiometricPromptTrackingPoint.SetupLaterClick]:
    'f4ad8c27-e045-4322-a877-5be50220b0e0',
  [BiometricPromptTrackingPoint.EnableSuccessImpression]:
    '4e375dda-5d99-49f0-819a-ed66ad1edc09',
  [BiometricPromptTrackingPoint.EnableSuccessOkClick]:
    '42d5c079-68aa-4964-af26-b13790f847ad',
  [BiometricPromptTrackingPoint.EnableFailTooManyTimesOkClick]:
    '092db2fb-58f5-4f50-9f45-4295c2fe85bb',
  [BiometricPromptTrackingPoint.EnableFailTooManyTimesImpression]:
    '4569c9d5-8773-45da-9544-b3307d86607d',
};

const ReloginBiometricsTrackingSchema: Record<
  ReloginBiometricsTrackingPoint,
  string
> = {
  [ReloginBiometricsTrackingPoint.PageView]:
    '0ea09faf-7346-4a1d-b6aa-78d67924b667',
  [ReloginBiometricsTrackingPoint.ReloginBiometricLoginClick]:
    '4f58eb06-9937-4003-a1f6-a31ff5b3c6fe',
  [ReloginBiometricsTrackingPoint.ReloginSignupClick]:
    'e627261d-5f3a-422c-b27b-9343e3bbce07',
  [ReloginBiometricsTrackingPoint.ReloginWithAnotherAccountClick]:
    '6b82f172-9b33-4894-9eec-eef9d6b3834f',
  [ReloginBiometricsTrackingPoint.ReloginWithOtherMethodsClick]:
    '3dc6795c-65d3-4ace-bbd9-780d1727aa51',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsSelectionImpression]:
    'f9b6b975-c0e1-4663-8182-c9f7ab7473e4',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithPhoneClick]:
    '8623b1a4-da9c-4f74-8abe-d128f3ee6e88',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithPasswordClick]:
    '',
  [ReloginBiometricsTrackingPoint.LoginWithOtherMethodsLoginWithQuickLoginClick]:
    '69a13ece-603f-49c5-aade-8dcbb3fe9572',
  [ReloginBiometricsTrackingPoint.QuickLoginToggleImpression]:
    '4957467c-f069-4aee-9b12-647d3fb836b3',
  [ReloginBiometricsTrackingPoint.QuickLoginToggleClick]:
    '892ab754-837a-4802-a902-651865a10708',
  [ReloginBiometricsTrackingPoint.QuickLoginTooltipImpression]:
    'ade26bef-cfa7-45ee-a97d-4a8ec255cf13',
  [ReloginBiometricsTrackingPoint.QuickLoginActionSuccess]:
    '347be15a-72e9-4023-8467-7f68fa093344',
};

const ReloginPasswordTrackingSchema: Record<
  ReloginPasswordTrackingPoint,
  string
> = {
  [ReloginPasswordTrackingPoint.PageView]:
    '817243a0-eea6-401b-876f-153e074df65f',
  [ReloginPasswordTrackingPoint.ReloginSignupClick]: '',
  [ReloginPasswordTrackingPoint.ReloginWithAnotherAccountClick]: '',
  [ReloginPasswordTrackingPoint.ReloginWithOtherMethodsClick]:
    'ee3e6cc8-a5b8-4a36-a5d2-1ab46f7f168a',
  [ReloginPasswordTrackingPoint.ReloginWithPasswordLoginClick]: '',

  [ReloginPasswordTrackingPoint.ForgotPasswordClick]:
    '6567b882-48a9-4b1d-ba68-edcf0f3c0af3',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsSelectionImpression]:
    '3011bfcc-2897-4e02-b24b-8466140635cf',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithBiometricsClick]:
    '07d5cff2-9268-4a85-8d11-00443ab484c8',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithPhoneClick]:
    '4366fe28-80de-47bf-9937-bc8c20eebd0d',
  [ReloginPasswordTrackingPoint.LoginWithOtherMethodsLoginWithQuickLoginClick]:
    'd5af761f-9d3f-409a-91f5-b3e86444d491',
  [ReloginPasswordTrackingPoint.ReloginHelpClick]:
    '0cf7946d-e489-431c-9a4a-080cf803fb6a',
  [ReloginPasswordTrackingPoint.QuickLoginToggleImpression]:
    'd519608f-44b5-46a4-b266-b2a2527d9665',
  [ReloginPasswordTrackingPoint.QuickLoginToggleClick]:
    '65c53d41-c121-4971-b79b-0aafd8379692',
  [ReloginPasswordTrackingPoint.QuickLoginTooltipImpression]:
    '0e0dff85-df31-43f1-aa7c-b4e4ec5ecb35',
  [ReloginPasswordTrackingPoint.QuickLoginActionSuccess]:
    '7c94dbdd-a516-4fb2-9cb2-e2205d729138',
};

export const getBiometricPromptPageTypeAndSchema = (
  trackingPoint: BiometricPromptTrackingPoint
) => {
  return {
    page_type: PageType.BiometricPromptPage,
    schema: BiometricPromptTrackingSchema[trackingPoint],
  };
};

export const getReloginBiometricsPageTypeAndSchema = (
  trackingPoint: ReloginBiometricsTrackingPoint
) => {
  return {
    page_type: PageType.ReloginBiometricsPage,
    schema: ReloginBiometricsTrackingSchema[trackingPoint],
  };
};

export const getReloginPasswordPageTypeAndSchema = (
  trackingPoint: ReloginPasswordTrackingPoint
) => {
  return {
    page_type: PageType.ReloginPasswordPage,
    schema: ReloginPasswordTrackingSchema[trackingPoint],
  };
};
